<template>
  <div v-if="fetched">
    <div v-if="no_modules_available">
      <div class="card">
        <div class="card-body">
          <span>{{$t($route.name+".noModulesFound")}}</span>
        </div>
      </div>
    </div>
    <div id="map" v-else>
      <GoogleMap
        :module_list="module_list"
        :key="fetched"
      />
    </div>
  </div>
  <div v-else>
    <span>
      {{$t($route.name+".loadingModules")}}
    </span>
  </div>
</template>

<script>

import LandlordService from "@/services/landlord.service"
//import DataService from "@/services/data.service"
import GoogleMap from "../../components/GoogleMap.vue"

export default {
  name: "ModulesMapBox",
  components: {
    GoogleMap
},
  data() {
    return {
      module_list: [],
      //modules: [],
      fetched: false,
      no_modules_available: false,
    }
  },
  created(){
    const user = JSON.parse(localStorage.getItem("user")).user;
    
    LandlordService.getLandlordAllModules(user.id).then(
      data => {
        this.module_list = data.module_list;
        if(this.module_list.length == 0){
          this.no_modules_available = true;
        }else{
          this.no_modules_available = false;
        }
        
        this.fetched = true
        
      }
    )
  },
  mounted(){
    
    // setTimeout(this.dataUpdate, 1000);
     
  },
  methods: {
    
    // dataUpdate: function(){
    //   const date = new Date();
    //   const date_formated = date.toISOString().split('T')[0].replaceAll('-','')

    //   this.module_list.forEach(module => {
    //     DataService.getDataByModuleIdAndDate(module.id, date_formated).then(
    //       data => {
          
    //         const latest = data[0];

    //         const lat = latest.processed.location.latitude == 0 ? module.latitude : latest.processed.location.latitude;
    //         const lon = latest.processed.location.longitude == 0 ? module.longitude : latest.processed.location.longitude;

    //         let module_data = {
    //           module_name:  module.name,
    //           longitude:    lon,
    //           latitude:     lat,
    //           values:       {},
    //         }

    //         latest.processed.sensors_data.forEach(sensor => {
    //           switch(sensor.measure){
    //             case 'temp_meter':
    //               module_data.values["temperature"] = sensor.value
    //               break;
    //             case 'rain_meter':
    //               module_data.values["rainmeter"] = sensor.value
    //               break;
    //             case 'hum_meter':
    //               module_data.values["humidity"] = sensor.value
    //               break;
    //             default:
    //               break;
    //           }
    //         });

    //         this.modules.push(
    //           module_data
    //         );

    //         this.dataFetched = true;
    //       },
    //       () => {
    //         let module_data = {
    //           module_name:  module.name,
    //           longitude:    module.longitude,
    //           latitude:     module.latitude,
    //           values:       {
    //             temperature:  0,
    //             humidity:     0,
    //             rainmeter:    0
    //           },
    //         };

    //         this.modules.push(
    //           module_data
    //         );
    //       });
    //   });
    // }
  }
}
</script>
<style></style>